import { jsx as _jsx } from "react/jsx-runtime";
/**
 * クリップボードコピーボタンコンポーネント
 *
 * テキストをクリップボードにコピーする汎用ボタン。
 * コピー成功時に2秒間フィードバックを表示。
 * className でスタイルをカスタマイズ可能。
 *
 * ref と残余プロップを内部の <button> へ転送するため、
 * Radix の `<TooltipTrigger asChild>` 等の直下へそのまま置ける。
 */
import { Check, Copy } from 'lucide-react';
import { forwardRef } from 'react';
import { useCopyToClipboard } from '../hooks/use-copy-to-clipboard';
import { cn } from '../utils';
export const CopyButton = forwardRef(function CopyButton({ content, className, 'aria-label': ariaLabel, onCopyError, onClick, type = 'button', ...rest }, ref) {
    const { copied, copy } = useCopyToClipboard({ onError: onCopyError });
    // asChild 経由で注入された onClick も失わないよう、呼び出し側のハンドラを先に実行する
    const handleClick = (event) => {
        onClick?.(event);
        copy(content);
    };
    return (_jsx("button", { ...rest, ref: ref, type: type, onClick: handleClick, className: cn('inline-flex h-6 w-6 items-center justify-center rounded transition-colors', className), "aria-label": ariaLabel ?? 'コピー', children: copied ? (_jsx(Check, { className: "h-3.5 w-3.5 text-green-500", "data-testid": "copy-success" })) : (_jsx(Copy, { className: "h-3.5 w-3.5", "data-testid": "copy-idle" })) }));
});
//# sourceMappingURL=CopyButton.js.map